import React, { Component } from 'react';
import { Button, Col, Grid, Modal, Row, Glyphicon, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import OverlayLoader from './overlayLoader';
import Dropzone from 'react-dropzone';
import uniqueId from '../common/uniqueId';
import './accountsAddDialog.css';

class AccountsAddDialog extends Component {

  initState = {
    files: [],
    selectedProviderId: '',
  };

  constructor(props) {
    super(props);
    this.state = this.initState;
  }
  isFetching = this.props.isLoading;

  onClose = () => {
    this.props.onClose();
  };

  onDrop = (acceptedFiles) => {
    const { maxFileSize, maxFilesCount } = this.props;
    const filteredFiles = acceptedFiles.filter((file) => {
      const { size } = file;
      if (size > maxFileSize) {
        return false;
      }
      return true;
    })

    filteredFiles.map((file) => Object.assign(file, {
      id: uniqueId(),
    }));

    const newFiles = [...this.state.files, ...filteredFiles];
    if (newFiles.length > maxFilesCount) {
      console.log(newFiles.length, maxFilesCount)
    }
    this.setState({ files: newFiles.slice(0, maxFilesCount) });
  };

  handleRemove = (id) => () => {
    const restFiles = this.state.files.filter((i) => i.id !== id);
    this.setState({ files: restFiles });
  };

  onSubmit = () => {
    this.props.onUpload(this.state.files, this.state.selectedProviderId || null)
  }

  isSubmitButtonDisabled = () => this.state.files.length === 0 || this.state.selectedProviderId === '';

  onShow = () => {
    this.setState(this.initState);
  };

  onSelectedProviderChange = (e) => {
    const { value: id } = e.target;
    this.setState({ selectedProviderId: id });
  };

  isSelectedProviderDisabled = () => {
    return this.props.providersState.isFetching;
  };

  render() {
    const isDisabled = this.props.disabled || this.state.files.length >= this.props.maxFilesCount;

    return (
      <Modal show={this.props.show} onShow={this.onShow} onHide={this.onClose} backdrop="static">
        <Modal.Header>
          <Modal.Title>{this.props.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="noPadding">
          <OverlayLoader
            active={this.isFetching}
            text={this.props.loaderMessage}
          >
            <Grid fluid className="noPadding">
              <Dropzone onDrop={this.onDrop}
                        disabled={isDisabled}
                        accept={this.props.accept}
                        maxSize={this.props.maxFileSize}
              >
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()} className={`dropzone ${isDisabled ? 'disabled' : ''}`}>
                    <input {...getInputProps()} />
                    {isDisabled
                      ? <span>Max files count</span>
                      : <span>Drag 'n' drop some files here, or click to select files</span>
                    }
                  </div>
                )}
              </Dropzone>
            </Grid>
          <Grid fluid>
            <Row>
              {this.state.files.map((i) => {
                return (
                  <Col xs={6} md={6} key={`file-${i.id}`}>
                    <div className="files-list-item">
                      <span className="file-icon">
                        <Glyphicon glyph="file" />
                      </span>
                      <span className="file-name" title={i.name}>{i.name}</span>
                      <span className="remove-icon" title="Remove file from list" onClick={this.handleRemove(i.id)}>
                        <Glyphicon glyph="remove" />
                      </span>
                    </div>
                  </Col>
                )
              })}
            </Row>
          </Grid>
            <br/>
            <Grid fluid>
              <FormGroup controlId="fcLProvider">
                <ControlLabel>AI Provider</ControlLabel>
                <FormControl
                  componentClass="select"
                  placeholder="AI provider"
                  value={this.state.selectedProviderId}
                  onChange={this.onSelectedProviderChange}
                  disabled={this.isSelectedProviderDisabled()}
                >
                  <option value='' disabled>Select provider...</option>
                  {this.props.providersState.data.map(provider => {
                    return (
                      <option key={provider.id} value={provider.id}>{provider.name}</option>
                    );
                  })}
                </FormControl>
              </FormGroup>
            </Grid>
          </OverlayLoader>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={this.onSubmit}
            disabled={this.isSubmitButtonDisabled()}
          >
            Upload
          </Button>
          <Button onClick={this.onClose}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

AccountsAddDialog.defaultProps = {
  maxFileSize: 52428800, //50 MB
  maxFilesCount: 10,
  disabled: false,
  loaderMessage: 'Uploading...',
};

export default AccountsAddDialog;



// WEBPACK FOOTER //
// ./src/components/accountsAddDialog.js